<template>
  <svg
    v-if="name"
    :width="width"
    :height="height"
    :class="[
      className,
      { 'anz-svg-icon': !stroke, 'anz-svg-icon-stroke': stroke },
    ]"
  >
    <use :xlink:href="'#anz-icon-' + name"></use>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AIcon',
  props: {
    name: {
      type: String,
      default: '',
      required: true,
    },
    width: {
      type: String,
      default: '10px',
    },
    height: {
      type: String,
      default: '10px',
    },
    stroke: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: 'anz-svg-icon',
    },
  },
})
</script>
